export default "__VITE_ASSET__DOZVB1aD__"